module.exports = __webpack_public_path__ + "img/int.730534c2.png";